var cov_2nvtu4kx4p = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/request.ts",
      hash = "ea46a654d1955b709b5c9f20e7cde737cd576257",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/request.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 3,
          column: 26
        }
      },
      "1": {
        start: {
          line: 4,
          column: 23
        },
        end: {
          line: 4,
          column: 24
        }
      },
      "2": {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 5,
          column: 22
        }
      },
      "3": {
        start: {
          line: 10,
          column: 35
        },
        end: {
          line: 10,
          column: 55
        }
      },
      "4": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 31
        }
      },
      "6": {
        start: {
          line: 14,
          column: 9
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "7": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 30
        }
      },
      "8": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 25
        }
      },
      "9": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 14
        }
      },
      "10": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 12
        }
      },
      "11": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 10
        }
      },
      "12": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "13": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 75
        }
      },
      "14": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 20
        }
      },
      "15": {
        start: {
          line: 46,
          column: 15
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "16": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 49,
          column: 4
        }
      },
      "17": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 29
        }
      },
      "18": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 25
        }
      },
      "19": {
        start: {
          line: 54,
          column: 14
        },
        end: {
          line: 54,
          column: 50
        }
      },
      "20": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 28
        }
      },
      "21": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 28
        }
      },
      "22": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 41
        }
      },
      "23": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "24": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 35
        }
      },
      "25": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 76
        }
      },
      "26": {
        start: {
          line: 60,
          column: 18
        },
        end: {
          line: 60,
          column: 76
        }
      },
      "27": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 61,
          column: 50
        }
      },
      "28": {
        start: {
          line: 61,
          column: 20
        },
        end: {
          line: 61,
          column: 50
        }
      },
      "29": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 23
        }
      },
      "30": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 66,
          column: 4
        }
      },
      "31": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 39
        }
      },
      "32": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "33": {
        start: {
          line: 68,
          column: 15
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "34": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 70,
          column: 16
        }
      },
      "35": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 72,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "createCORSRequest",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 26
          }
        },
        loc: {
          start: {
            line: 9,
            column: 56
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 15
          },
          end: {
            line: 25,
            column: 16
          }
        },
        loc: {
          start: {
            line: 25,
            column: 50
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 30
          },
          end: {
            line: 47,
            column: 31
          }
        },
        loc: {
          start: {
            line: 47,
            column: 35
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 61,
            column: 15
          },
          end: {
            line: 61,
            column: 16
          }
        },
        loc: {
          start: {
            line: 61,
            column: 20
          },
          end: {
            line: 61,
            column: 50
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 32
          }
        },
        loc: {
          start: {
            line: 64,
            column: 36
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 35,
            column: 13
          },
          end: {
            line: 35,
            column: 15
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 36,
            column: 14
          },
          end: {
            line: 36,
            column: 16
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }, {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 28
          }
        }, {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 28
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }, {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 76
          }
        }, {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 76
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        }, {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export var UPLOADING = (cov_2nvtu4kx4p.s[0]++, 1);
export var SUCCESS = (cov_2nvtu4kx4p.s[1]++, 2);
export var ERROR = (cov_2nvtu4kx4p.s[2]++, 3);

function createCORSRequest(method, url) {
  cov_2nvtu4kx4p.f[0]++;
  var xhr = (cov_2nvtu4kx4p.s[3]++, new XMLHttpRequest());
  cov_2nvtu4kx4p.s[4]++;

  if ('withCredentials' in xhr) {
    cov_2nvtu4kx4p.b[0][0]++;
    cov_2nvtu4kx4p.s[5]++;
    // XHR for Chrome/Firefox/Opera/Safari.
    xhr.open(method, url, true);
  } else {
    cov_2nvtu4kx4p.b[0][1]++;
    cov_2nvtu4kx4p.s[6]++;

    if (typeof XDomainRequest !== 'undefined') {
      cov_2nvtu4kx4p.b[1][0]++;
      cov_2nvtu4kx4p.s[7]++;
      // XDomainRequest for IE.
      xhr = new XDomainRequest();
      cov_2nvtu4kx4p.s[8]++;
      xhr.open(method, url);
    } else {
      cov_2nvtu4kx4p.b[1][1]++;
      cov_2nvtu4kx4p.s[9]++;
      // CORS not supported.
      xhr = null;
    }
  }

  cov_2nvtu4kx4p.s[10]++;
  return xhr;
}

export default function (args) {
  cov_2nvtu4kx4p.f[1]++;

  var _ref = (cov_2nvtu4kx4p.s[11]++, args),
      url = _ref.url,
      name = _ref.name,
      cors = _ref.cors,
      file = _ref.file,
      onProgress = _ref.onProgress,
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      withCredentials = _ref.withCredentials,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? (cov_2nvtu4kx4p.b[2][0]++, {}) : _ref$params,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? (cov_2nvtu4kx4p.b[3][0]++, {}) : _ref$headers,
      onStart = _ref.onStart,
      responseType = _ref.responseType;

  cov_2nvtu4kx4p.s[12]++;

  if (!url) {
    cov_2nvtu4kx4p.b[4][0]++;
    cov_2nvtu4kx4p.s[13]++;
    console.error(new Error("action is required, but its value is ".concat(url)));
    cov_2nvtu4kx4p.s[14]++;
    return undefined;
  } else {
    cov_2nvtu4kx4p.b[4][1]++;
  }

  var data = (cov_2nvtu4kx4p.s[15]++, new FormData());
  cov_2nvtu4kx4p.s[16]++;
  Object.keys(params).forEach(function (k) {
    cov_2nvtu4kx4p.f[2]++;
    cov_2nvtu4kx4p.s[17]++;
    data.append(k, params[k]);
  });
  cov_2nvtu4kx4p.s[18]++;
  data.append(name, file); // @ts-ignore 多传了一个参数

  var xhr = (cov_2nvtu4kx4p.s[19]++, createCORSRequest('post', url, cors));
  cov_2nvtu4kx4p.s[20]++;

  if (!xhr) {
    cov_2nvtu4kx4p.b[5][0]++;
    cov_2nvtu4kx4p.s[21]++;
    return undefined;
  } else {
    cov_2nvtu4kx4p.b[5][1]++;
  }

  cov_2nvtu4kx4p.s[22]++;
  xhr.withCredentials = !!withCredentials;
  cov_2nvtu4kx4p.s[23]++;

  if (responseType) {
    cov_2nvtu4kx4p.b[6][0]++;
    cov_2nvtu4kx4p.s[24]++;
    xhr.responseType = responseType;
  } else {
    cov_2nvtu4kx4p.b[6][1]++;
  }

  cov_2nvtu4kx4p.s[25]++;

  if (onProgress) {
    cov_2nvtu4kx4p.b[7][0]++;
    cov_2nvtu4kx4p.s[26]++;
    xhr.upload.addEventListener('progress', onProgress, false);
  } else {
    cov_2nvtu4kx4p.b[7][1]++;
  }

  cov_2nvtu4kx4p.s[27]++;

  xhr.onload = function (e) {
    cov_2nvtu4kx4p.f[3]++;
    cov_2nvtu4kx4p.s[28]++;
    return onLoad(e.currentTarget);
  };

  cov_2nvtu4kx4p.s[29]++;
  xhr.onerror = onError;
  cov_2nvtu4kx4p.s[30]++;
  Object.keys(headers).forEach(function (k) {
    cov_2nvtu4kx4p.f[4]++;
    cov_2nvtu4kx4p.s[31]++;
    xhr.setRequestHeader(k, headers[k]);
  });
  cov_2nvtu4kx4p.s[32]++;

  if (onStart) {
    cov_2nvtu4kx4p.b[8][0]++;
    cov_2nvtu4kx4p.s[33]++;
    onStart(file);
  } else {
    cov_2nvtu4kx4p.b[8][1]++;
  }

  cov_2nvtu4kx4p.s[34]++;
  xhr.send(data);
  cov_2nvtu4kx4p.s[35]++;
  return xhr;
}